import { useEffect } from 'react';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { getTeamsNames } from './views/CustomReport/Filters/TeamsDropdown';
import useFilters from './useFilters';
import useTeamGoalsDashboard from './useTeamGoalsDashboard';
import { useDispatch } from 'react-redux';
import { setSelectedTeamChangedFromTopBar } from 'state/actions/ui-state';

const useTeamGoals = gitScopeToggle => {
  const dispatch = useDispatch();
  const filters = useFilters({ isTeamGoals: true });
  const teamGoals = useTeamGoalsDashboard({ filters, gitScopeToggle });

  useEffect(() => {
    TrackingService.logEvent(TRACKING.EVENTS.VISIT, {
      page: TRACKING.PAGES.METRICS,
      team_names: getTeamsNames(filters.globallySelectedTeams)
    });

    window.scrollTo({ top: 0, behavior: 'instant' });
    return () => {
      dispatch(setSelectedTeamChangedFromTopBar(false));
    };
  }, []);

  return {
    loaded: teamGoals.loaded,
    customDashboardsFiltered: teamGoals.customDashboardsFiltered
  };
};

export default useTeamGoals;
